import React, { Component } from "react";
import { connect } from "react-redux";
import { Breadcrumb, Modal } from "react-bootstrap";
import Select from "react-select";
import Moment from "react-moment";
import Spinner from "react-bootstrap/Spinner";
import { FaTrashAlt } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { BsSave } from "react-icons/bs";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Collapse,
  CardBody,
  Card,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import {
  MdOutlineCheck,
  MdOutlineChevronLeft,
  MdOutlineClose,
} from "react-icons/md";
import { toast } from "react-toastify";

class edocTypeCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eDocTypeId: 0,
      eDocTypeName: "",
      applicablefor: "",
      status: "",
      userId: "",
      eDocType: "",
      wfUserdefined: 1,
      approversection: "",
      approverList: [],
      applicableArray: [],
      statusArray: [],
      approverEdit: {
        status: false,
        value: "",
      },
      sequence_no: "",
      errorStatus: false,
      ApproverReferencesAdd: "none",
      ApproverShowReferenceRequired: "none",
      approverRequesterId: "",
      approverRequesterName: "",
      approverRequesterSection: "",
      approverRequesterSectionName: "",
      approverRequesterDepartment: "",
      approverRequesterDivision: "",
      approverRequesterDesignation: "",
      approverCanStafNamePopover: "flex",
      approverGetEmployeeFirstShow: "",
      approverRequesterDisplayName: "",
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
      approverStaffDetailslistArraySpin: "none",
      sectionListArray: [],
      approverpopupEmployeeName: "",
      stafflistArraySpin: "none",
    };
  }
  componentDidMount() {
    this.GetApplicableArray();
    this.SectionListData();
  }

  GetApplicableArray = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/Admin/ApplicableforDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              applicableArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };
  SectionListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/SectionDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              sectionListArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  changeHandler = (value, type) => {
    switch (type) {
      case "eDocTypeName":
        this.setState({ eDocTypeName: value });
        break;
      case "applicablefor":
        let temp = [];
        value?.map((dt) => temp.push(dt.value));
        this.setState({ applicablefor: temp });
        break;
      case "status":
        this.setState({ status: value });
        break;
      case "wfUserdefined":
        this.setState({ wfUserdefined: value });
        break;
      case "approversection":
        this.setState({ approverpopupSection: value });
        break;
      default:
        break;
    }
  };

  addApproverReferences = () => {
    this.setState({
      ApproverReferencesAdd: true,
      ApproverShowReferenceRequired: "none",
      sequence_no: this.state.approverList.length + 1,
    });
  };

  handleChange = (e) => {
    switch (e.target.name) {
      case "approverpopupEmployeeId":
        this.setState({
          ...this.state,
          approverpopupEmployeeId: e.target.value,
        });
        break;
      case "sequence_no":
        this.setState({ ...this.state, sequence_no: e.target.value });
        break;
      case "approverpopupEmployeeName":
        this.setState({
          ...this.state,
          approverpopupEmployeeName: e.target.value,
        });
        break;

      default:
        break;
    }
  };

  approverShowFirstStaffPopup = () => {
    this.setState({ approverGetEmployeeFirstShow: true });
  };

  approverHideFirstStaffPopup = () => {
    this.setState({ approverGetEmployeeFirstShow: false });
    this.setState({
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
    });
  };

  approversearchEmployee = () => {
    try {
      this.setState({ approverStaffDetailslistArraySpin: "" });
      let postData = {
        employeeId: this.state.approverpopupEmployeeId,
        name: this.state.approverpopupEmployeeName,
        section: this.state.approverpopupSection.value,
        employeeType: "",
      };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ approverStaffDetailslistArray: data.resultObject });
            this.setState({ approverStaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  approversearchEmployeeClear = () => {
    this.setState({
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  approverGetStaffDetails = (
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation
  ) => {
    this.setState({
      approverRequesterId: id,
      approverRequesterName: name,
      approverRequesterSection: section,
      approverRequesterSectionName: sectionName,
      approverRequesterDepartment: department,
      approverRequesterDivision: division,
      approverRequesterDesignation: designation,
      approverCanStafNamePopover: "flex",
      approverGetEmployeeFirstShow: false,
      approverRequesterDisplayName: id + " - " + name,
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
    });
  };

  approverReferences_Save = () => {
    let temp = [...this.state.approverList];
    let obj = {
      seqNo: parseInt(this.state.sequence_no),
      section: this.state.approverRequesterSection,
      employeeId: this.state.approverRequesterId,
      employeeName: this.state.approverRequesterName,
    };
    if (temp?.length) {
      this.setState({
        approverList: [...this.state.approverList, obj],
        approverEdit: {
          status: false,
          value: "",
        },
        sequence_no: "",
        errorStatus: false,
        ApproverReferencesAdd: "none",
        ApproverShowReferenceRequired: "none",
        approverRequesterId: "",
        approverRequesterName: "",
        approverRequesterSection: "",
        approverRequesterSectionName: "",
        approverRequesterDepartment: "",
        approverRequesterDivision: "",
        approverRequesterDesignation: "",
        approverCanStafNamePopover: "flex",
        approverGetEmployeeFirstShow: "",
        approverRequesterDisplayName: "",
        approverpopupEmployeeId: "",
        approverpopupEmployeeName: "",
        approverpopupSection: 0,
        approverStaffDetailslistArray: [],
      });
    } else {
      this.setState({
        approverList: [obj],
        approverEdit: {
          status: false,
          value: "",
        },
        sequence_no: "",
        errorStatus: false,
        ApproverReferencesAdd: "none",
        ApproverShowReferenceRequired: "none",
        approverRequesterId: "",
        approverRequesterName: "",
        approverRequesterSection: "",
        approverRequesterSectionName: "",
        approverRequesterDepartment: "",
        approverRequesterDivision: "",
        approverRequesterDesignation: "",
        approverCanStafNamePopover: "flex",
        approverGetEmployeeFirstShow: "",
        approverRequesterDisplayName: "",
        approverpopupEmployeeId: "",
        approverpopupEmployeeName: "",
        approverpopupSection: 0,
        approverStaffDetailslistArray: [],
      });
    }
  };

  saveEdocType = () => {
    try {
      let temp = this.state.applicablefor.length
        ? this.state.applicablefor?.join(",")
        : "";
      let postData = {
        eDocTypeId: this.state.eDocTypeId,
        eDocTypeName: this.state.eDocTypeName,
        applicablefor: temp,
        status: this.state.status.value,
        wfUserdefined: this.state.wfUserdefined,
        userId: this.props.UserId,
        approverList: this.state.approverList,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/Admin/CreateeDocType",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            toast.success("Successfully created.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            this.props.history.push({ pathname: "/edoctype/list" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  removeApp = (value) => {
    let temp = [];
    this.state.approverList?.map(
      (dt) => dt.employeeId != value.employeeId && temp.push(dt)
    );
    this.setState({ approverList: temp });
  };

  updateApp = (value) => {
    let obj = {
      seqNo: parseInt(
        this.state.sequence_no ? this.state.sequence_no : value.seqNo
      ),
      section: this.state.approverRequesterSection
        ? this.state.approverRequesterSection
        : value.section,
      employeeId: this.state.approverRequesterId
        ? this.state.approverRequesterId
        : value.employeeId,
      employeeName: this.state.approverRequesterName
        ? this.state.approverRequesterName
        : value.employeeName,
    };
    let temp = [obj];
    this.state.approverList?.map(
      (dt) => dt.employeeId != value.employeeId && temp.push(dt)
    );
    this.setState({
      approverList: temp,
      approverEdit: {
        status: false,
        value: "",
      },
      sequence_no: "",
      errorStatus: false,
      ApproverReferencesAdd: "none",
      ApproverShowReferenceRequired: "none",
      approverRequesterId: "",
      approverRequesterName: "",
      approverRequesterSection: "",
      approverRequesterSectionName: "",
      approverRequesterDepartment: "",
      approverRequesterDivision: "",
      approverRequesterDesignation: "",
      approverCanStafNamePopover: "flex",
      approverGetEmployeeFirstShow: "",
      approverRequesterDisplayName: "",
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
    });
  };

  render() {
    let SectionTypeOptionList = [];
    let statusOptionList = [
      { label: "Active", value: 1 },
      { label: "Inactive", value: 0 },
    ];
    let applicableList = [];
    if (this.state.applicableArray.length > 0) {
      this.state.applicableArray.map((data) => {
        let sData = {
          id: data.code,
          label: data.description,
          value: data.code,
        };
        applicableList.push(sData);
        return null;
      });
    }

    if (this.state.sectionListArray.length > 0) {
      this.state.sectionListArray.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.code,
        };
        SectionTypeOptionList.push(sData);
        return null;
      });
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/edoctype/list"}>
            eDoc Type
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Create</Breadcrumb.Item>
        </Breadcrumb>
        <Modal show={this.state.approverGetEmployeeFirstShow} size="xl">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      name="approverpopupEmployeeId"
                      value={this.state.approverpopupEmployeeId}
                      onChange={this.handleChange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="approverpopupEmployeeName"
                      value={this.state.approverpopupEmployeeName}
                      onChange={this.handleChange}
                      // onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      value={this.state.approverpopupSection}
                      options={SectionTypeOptionList}
                      onChange={(value) =>
                        this.changeHandler(value, "approversection")
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.approversearchEmployeeClear()}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={() => this.approversearchEmployee()}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>

            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.approverStaffDetailslistArray?.map((staff) => (
                      <tr
                        className="cursor-pointer"
                        onClick={() =>
                          this.approverGetStaffDetails(
                            staff.employeeId,
                            staff.name,
                            staff.section,
                            staff.sectionName,
                            staff.department,
                            staff.division,
                            staff.designation
                          )
                        }>
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.employeeId} </td>
                        <td> {staff.name} </td>
                        <td> ({staff.account}) </td>
                        <td> {staff.email} </td>
                        <td> {staff.section} </td>
                        <td> {staff.sectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.approverStaffDetailslistArray?.length <= 0 &&
                    this.state.approverStaffDetailslistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{
                      display: this.state.approverStaffDetailslistArraySpin,
                    }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.approverHideFirstStaffPopup()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="content-area">
          <section className="view-taskpending-section">
            <div className="form-group mb-4">
              <h4>Create eDoc Type</h4>
            </div>
          </section>

          <section className="view-taskpending-section">
            <h2 className="form-heading">eDoc Type Information</h2>
            <div className="form-group row mb-0">
              <label for="" className="col-sm-3 requester-info  col-form-label">
                eDoc Type
              </label>
              <div className="col-sm-6">
                <FormGroup>
                  <Input
                    onChange={(e) =>
                      this.changeHandler(e.target.value, "eDocTypeName")
                    }
                    type="text"
                  />
                </FormGroup>
              </div>
            </div>
            <div className="form-group row mb-0 mt-4">
              <label for="" className="col-sm-3 requester-info  col-form-label">
                Applicable for
              </label>
              <div className="col-sm-6">
                <FormGroup>
                  <Select
                    isMulti
                    onChange={(value) =>
                      this.changeHandler(value, "applicablefor")
                    }
                    options={applicableList}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="form-group row mb-0 mt-4">
              <label for="" className="col-sm-3 requester-info  col-form-label">
                Status
              </label>
              <div className="col-sm-4">
                <FormGroup>
                  <Select
                    onChange={(value) => this.changeHandler(value, "status")}
                    options={statusOptionList}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="form-group row mb-4 mt-4">
              <label for="" className="col-sm-3 requester-info  col-form-label">
                Workflow User Defined
              </label>
              <div className="col-sm-6 ml-3">
                <div className="form-check form-check-inline">
                  <Input
                    onClick={() => this.setState({ wfUserdefined: 1 })}
                    checked={this.state.wfUserdefined == 1}
                    className="form-check-input"
                    type="radio"
                  />
                  <label
                    className="form-check-label text-muted"
                    for="inlineRadio1">
                    {" "}
                    Yes{" "}
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <Input
                    onClick={() => this.setState({ wfUserdefined: 0 })}
                    checked={this.state.wfUserdefined == 0}
                    className="form-check-input"
                    type="radio"
                  />
                  <label
                    className="form-check-label text-muted"
                    for="inlineRadio2">
                    {" "}
                    No{" "}
                  </label>
                </div>
              </div>
            </div>
          </section>
          <section className="view-taskpending-section">
            <h2 className="form-heading">Workflow Setup</h2>
            <div className="customized-table">
              <Card>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-body">
                      <section>
                        <h2 className="fs-title"> </h2>
                        <div className="customized-table">
                          <div className="table-responsive ">
                            <table className="table table-hover">
                              <thead className="thead-lightBlue">
                                <tr>
                                  <th scope="col" className="text-nowrap">
                                    Sequence No
                                  </th>
                                  <th scope="col" className="text-nowrap">
                                    Approver Name
                                  </th>
                                  <th scope="col" className="text-nowrap">
                                    Section
                                  </th>

                                  <th
                                    scope="col"
                                    className="text-nowrap float-right">
                                    Action
                                    <button
                                      className="btn btn-success btn-sm ml-2"
                                      onClick={this.addApproverReferences}>
                                      {" "}
                                      <span className="font-size-17">
                                        +
                                      </span>{" "}
                                    </button>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state?.approverList?.map((dt, index) => (
                                  <tr className="cursor-pointer">
                                    {this.state.approverEdit.status &&
                                    this.state.approverEdit.value == index ? (
                                      <td className="text-nowrap">
                                        <Input
                                          type="text"
                                          name="sequence_no"
                                          defaultValue={dt.seqNo}
                                          onChange={this.handleChange}
                                        />{" "}
                                      </td>
                                    ) : (
                                      <td className="text-nowrap">
                                        {dt.seqNo}
                                      </td>
                                    )}
                                    {this.state.approverEdit.status &&
                                    this.state.approverEdit.value == index ? (
                                      <td className="text-nowrap">
                                        <div>
                                          <div className="input-group mb-2 mr-sm-2">
                                            <input
                                              type="text"
                                              className="form-control"
                                              id=""
                                              placeholder=""
                                              readOnly={true}
                                              value={
                                                this.state
                                                  .approverRequesterDisplayName
                                              }
                                              onClick={
                                                this.approverShowFirstStaffPopup
                                              }
                                            />
                                            <div
                                              className="input-group-prepend"
                                              onClick={
                                                this.approverShowFirstStaffPopup
                                              }>
                                              <div className="input-group-text">
                                                <i className="fa fa-search text-muted">
                                                  {" "}
                                                </i>
                                              </div>
                                            </div>
                                            <div
                                              className="input-group-prepend ml-3"
                                              style={{
                                                display:
                                                  this.state
                                                    .approverCanStafNamePopover,
                                              }}>
                                              <button
                                                id="PopoverLegacy"
                                                className="input-group-text"
                                                type="button"
                                                data-toggle="popover"
                                                data-placement="bottom">
                                                <i className="fa fa-info text-muted">
                                                  {" "}
                                                </i>
                                              </button>
                                            </div>
                                          </div>

                                          <UncontrolledPopover
                                            trigger="legacy"
                                            placement="bottom"
                                            target="PopoverLegacy">
                                            <PopoverHeader></PopoverHeader>
                                            <PopoverBody>
                                              <div class="pop">
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Section
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterSection
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Department
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDepartment
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Division
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDivision
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Designation
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDesignation
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            </PopoverBody>
                                          </UncontrolledPopover>
                                        </div>
                                      </td>
                                    ) : (
                                      <td className="text-nowrap">
                                        {`${dt.employeeId} / ${dt.employeeName}`}
                                      </td>
                                    )}
                                    <td className="mt-3 text-nowrap">
                                      {dt?.section}
                                    </td>
                                    <td
                                      className="text-nowrap"
                                      style={{ textAlign: "end" }}>
                                      <div className="btn-group">
                                        {this.state.approverEdit.status ==
                                        false ? (
                                          <button
                                            className="btn btn-default btn-md"
                                            type="button"
                                            onClick={() =>
                                              this.setState({
                                                ...this.state,
                                                approverEdit: {
                                                  status: true,
                                                  value: index,
                                                },
                                              })
                                            }>
                                            {" "}
                                            <i
                                              className="fa fa-floppy-o text-muted"
                                              aria-hidden="true"></i>{" "}
                                            Edit{" "}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-default btn-md"
                                            type="button"
                                            onClick={() => this.updateApp(dt)}>
                                            {" "}
                                            <i
                                              className="fa fa-floppy-o text-muted"
                                              aria-hidden="true"></i>{" "}
                                            Save{" "}
                                          </button>
                                        )}
                                        <button
                                          className="btn btn-default btn-md ml-3"
                                          type="button"
                                          onClick={() => this.removeApp(dt)}>
                                          {" "}
                                          <i
                                            className="fa fa-trash-o text-muted"
                                            aria-hidden="true"></i>{" "}
                                          Remove{" "}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                                <tr
                                  style={{
                                    display: this.state.ApproverReferencesAdd,
                                  }}>
                                  <td className="text-nowrap">
                                    {" "}
                                    <Input
                                      type="text"
                                      name="sequence_no"
                                      value={this.state.sequence_no}
                                      onChange={this.handleChange}
                                    />{" "}
                                    {this.state.errorStatus &&
                                      !this.state.sequence_no && (
                                        <p
                                          style={{
                                            fontSize: 12,
                                            color: "red",
                                          }}>
                                          This field is required
                                        </p>
                                      )}
                                  </td>
                                  <td
                                    style={{ display: "contents" }}
                                    className="text-nowrap">
                                    <td>
                                      <div>
                                        <div className="input-group mb-2 mr-sm-2">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id=""
                                            placeholder=""
                                            readOnly={true}
                                            value={
                                              this.state
                                                .approverRequesterDisplayName
                                            }
                                            onClick={
                                              this.approverShowFirstStaffPopup
                                            }
                                          />

                                          <div
                                            className="input-group-prepend"
                                            onClick={
                                              this.approverShowFirstStaffPopup
                                            }>
                                            <div className="input-group-text">
                                              <i className="fa fa-search text-muted">
                                                {" "}
                                              </i>
                                            </div>
                                          </div>
                                          <div
                                            className="input-group-prepend ml-3"
                                            style={{
                                              display:
                                                this.state
                                                  .approverCanStafNamePopover,
                                            }}>
                                            <button
                                              id="PopoverLegacy"
                                              className="input-group-text"
                                              type="button"
                                              data-toggle="popover"
                                              data-placement="bottom">
                                              <i className="fa fa-info text-muted">
                                                {" "}
                                              </i>
                                            </button>
                                          </div>
                                          {this.state.errorStatus &&
                                            !this.state.approverRequesterId && (
                                              <p
                                                style={{
                                                  fontSize: 12,
                                                  color: "red",
                                                }}>
                                                This field is required
                                              </p>
                                            )}
                                        </div>

                                        <UncontrolledPopover
                                          trigger="legacy"
                                          placement="bottom"
                                          target="PopoverLegacy">
                                          <PopoverHeader></PopoverHeader>
                                          <PopoverBody>
                                            <div class="pop">
                                              <div class="row">
                                                <div class="col-xs-4 col-md-4">
                                                  Section
                                                </div>
                                                <div class="col-xs-8 col-md-8">
                                                  :{" "}
                                                  {
                                                    this.state
                                                      .approverRequesterSection
                                                  }
                                                </div>
                                              </div>
                                              <div class="row">
                                                <div class="col-xs-4 col-md-4">
                                                  Department
                                                </div>
                                                <div class="col-xs-8 col-md-8">
                                                  :{" "}
                                                  {
                                                    this.state
                                                      .approverRequesterDepartment
                                                  }
                                                </div>
                                              </div>
                                              <div class="row">
                                                <div class="col-xs-4 col-md-4">
                                                  Division
                                                </div>
                                                <div class="col-xs-8 col-md-8">
                                                  :{" "}
                                                  {
                                                    this.state
                                                      .approverRequesterDivision
                                                  }
                                                </div>
                                              </div>
                                              <div class="row">
                                                <div class="col-xs-4 col-md-4">
                                                  Designation
                                                </div>
                                                <div class="col-xs-8 col-md-8">
                                                  :{" "}
                                                  {
                                                    this.state
                                                      .approverRequesterDesignation
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </PopoverBody>
                                        </UncontrolledPopover>
                                      </div>
                                    </td>
                                  </td>
                                  <td className="text-nowrap">
                                    {" "}
                                    <input
                                      disabled
                                      className="form-control"
                                      name="editReferences_Remarks"
                                      value={
                                        this.state.approverRequesterSection
                                      }
                                      onChange={this.handleChange}
                                    />{" "}
                                  </td>
                                  <td
                                    className="text-nowrap"
                                    style={{ textAlign: "end" }}>
                                    <div className="btn-group">
                                      <button
                                        className="btn btn-default btn-md"
                                        type="button"
                                        onClick={this.approverReferences_Save}>
                                        {" "}
                                        <i
                                          className="fa fa-floppy-o text-muted"
                                          aria-hidden="true"></i>{" "}
                                        Save{" "}
                                      </button>
                                      <button
                                        className="btn btn-default btn-md ml-3"
                                        type="button"
                                        onClick={() =>
                                          this.setState({
                                            approverEdit: {
                                              status: false,
                                              value: "",
                                            },
                                            sequence_no: "",
                                            errorStatus: false,
                                            ApproverReferencesAdd: "none",
                                            ApproverShowReferenceRequired:
                                              "none",
                                            approverRequesterId: "",
                                            approverRequesterName: "",
                                            approverRequesterSection: "",
                                            approverRequesterSectionName: "",
                                            approverRequesterDepartment: "",
                                            approverRequesterDivision: "",
                                            approverRequesterDesignation: "",
                                            approverCanStafNamePopover: "flex",
                                            approverGetEmployeeFirstShow: "",
                                            approverRequesterDisplayName: "",
                                            approverpopupEmployeeId: "",
                                            approverpopupEmployeeName: "",
                                            approverpopupSection: 0,
                                            approverStaffDetailslistArray: [],
                                          })
                                        }>
                                        {" "}
                                        <i
                                          className="fa fa-trash-o text-muted"
                                          aria-hidden="true"></i>{" "}
                                        Remove{" "}
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div className="form-group row mb-0 mt-4">
              <div className="comments-button-style">
                <Button className="child-comments" outline color="primary">
                  <MdOutlineClose className="commects-icons" size={15} />
                  Cancel
                </Button>
                <Button
                  onClick={this.saveEdocType}
                  className="child-comments"
                  color="primary">
                  <BsSave className="commects-icons" size={15} />
                  Save
                </Button>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};
export default connect(mapStateToProps)(edocTypeCreate);
